import { useEffect } from 'react'
import { clearMedicareMyCookies, logoutFromOifIfLoggedIn } from 'utils/cookies'

export const useClearSPACookiesOnLogout = () => {
  useEffect(() => {
    const listener = () => {
      // Make best attempt to also hit backend oif logout
      logoutFromOifIfLoggedIn()
      // wait until after oif logout, so that the cookies are still available for the call to be made
      clearMedicareMyCookies()
    }
    document.addEventListener('cms-logout', listener)

    return () => {
      document.removeEventListener('cms-logout', listener)
    }
  }, [])
}
